import { Skeleton } from '@mui/material';

export const TableWidgetSkeleton = () => {
  return (
    <section
      className="table-default-section"
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        maxHeight: '100%',
        overflow: 'hidden',
      }}
    >
      <div className="table-default-section-header">
        <Skeleton variant="rounded" width={400} height={40} />
        <Skeleton variant="rounded" width={100} height={45} />
      </div>

      <div
        className="table-default-wrapper table-default-wrapper-fill"
        style={{ flex: 1, minHeight: 0, maxHeight: '100%' }}
      >
        <table className="table-default">
          <thead className="table-head">
            <tr className="table-row-head">
              {[...Array(4)].map((_, index) => (
                <th key={index} className="table-head-cell table-cell">
                  <Skeleton variant="text" width="100%" height={24} />
                </th>
              ))}
            </tr>
          </thead>

          <tbody className="table-body">
            {[...Array(10)].map((_, rowIndex) => (
              <tr key={rowIndex} className="table-body-row">
                {[...Array(4)].map((_, colIndex) => (
                  <td key={colIndex} className="table-body-cell table-cell">
                    <Skeleton variant="text" width="100%" height={20} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};
